module.exports = __webpack_public_path__ + "media/images/faq/brand2-6-cfed0eadfc5fab1b414bbe4ba312d6f7.png";